import React from 'react';

export const ButtonFinalize = ({
    buttonContinueAction,
    buttonContinueType,
    buttonFinalizeAndContinueHidden,
    buttonFinalizeDisabled,
    buttonFinalizeFakeDisabled,
    buttonFinalizeHidden,
    buttonFinalizeText,
}) => {
    const buttonClass =
        buttonFinalizeHidden || buttonFinalizeAndContinueHidden
            ? 'hidden'
            : `form__button form__button-secondary roadmap-navigation__button-continue roadmap-navigation__button-finalize ${
                  buttonFinalizeFakeDisabled ? 'disable-styles' : ''
              }`;

    return (
        <button
            className={buttonClass}
            disabled={buttonFinalizeDisabled}
            type={buttonContinueType}
            onClick={buttonContinueAction}
        >
            {buttonFinalizeText}
        </button>
    );
};
